var navigationController = (function($) {
	var navigation = {
		get navDOMObjHeight() {
			return $('header.main-header').outerHeight();
		},

		get searchDOMObjHeight() {
			return $('header.main-header nav.main-search').outerHeight();
		},

		get pinPadHeight() {
			return $('nav.main-nav').outerHeight();
		},

		// Init global properties and actions: run on page ready
		init: function() {
			// this.pinNav();
			this.scrollActivateNav();
			this.columizeMeganav();
			this.columizeFooterMeganav();
			this.mobileMenuActions();
			this.activateSplitMenus();
			this.touchDesktopMenus();
		},

		/**
		 * Set active menu color upon page scroll
		 */
		scrollActivateNav: function() {

			var is_home = ($('body.home').length > 0 ? true : false);

			$(window).on('scroll', function() {
				if ($(window).scrollTop() >= 5) {
					$('body').addClass('nav-scrolled');
					if (is_home) {
						$('body').addClass('nav-active');
					}
				} else {
					$('body').removeClass('nav-scrolled');
					if (is_home) {
						$('body').removeClass('nav-active');
					}
				}
			});
			if (is_home) {
				$('nav.main-nav').on('mouseover', function() {
					$('body').addClass('nav-active');
				});
				$('nav.main-nav').on('mouseout', function() {
					if ($(window).scrollTop() < 5) {
						$('body').removeClass('nav-active');
					}
				});
			}
		},

		/**
		 * Set menu to fixed position when scrolled past target
		 * Deprecated on 201808 redesign
		 */
		pinNav: function() {
			$(window).on('scroll', function() {
				// If we've scrolled past the height of our target object, add a class to the BODY
				// which triggers the applicable CSS rules
				if ($(window).scrollTop() >= navigation.searchDOMObjHeight) {
					$('body')
						.addClass('pinned-nav')
						.css('padding-top', navigation.pinPadHeight);
				} else {
					// Otherwise, return things to the way they were
					$('body')
						.removeClass('pinned-nav')
						.css('padding', '');
				}
			});
		},

		/**
		 * Create three-column meganav from existing UL structure
		 */
		columizeMeganav: function() {
			if ($('.nav-main__item--mega-nav').length > 0) {
				var outerElement = $('.nav-main__item--mega-nav > ul.nav-main__sub-menu--1');
				if (outerElement.length > 0) {
					var col1 = $('<ul/>')
							.append(outerElement.find('.nav-main__item--col1').clone())
							.html(),
						col2 = $('<ul/>')
							.append(outerElement.find('.nav-main__item--col2').clone())
							.html(),
						col3 = $('<ul/>')
							.append(outerElement.find('.nav-main__item--col3').clone())
							.html(),
						col4 = $('<ul/>')
							.append(outerElement.find('.nav-main__item--col4').clone())
							.html();

					outerElement.empty().append('<li><ul class="meganav-outer"><li class="col1"><ul>' + col1 + '</ul></li><li class="separator"></li><li class="col2"><ul>' + col2 + '</ul></li><li class="separator"></li><li class="col3"><ul>' + col3 + '</ul></li><li class="separator"></li><li class="col4"><ul>' + col4 + '</ul></li></ul></li>');
				}
			}
		},

		/**
		 * Create five-column footer meganav from existing UL structure
		 */
		columizeFooterMeganav: function() {
			if ($('nav.footer-nav').length > 0) {
				var outerElement = $('nav.footer-nav > div > ul.nav-ftr');
				if (outerElement.length > 0) {
					var col0 = $('<ul/>')
							.append(outerElement.find('.nav-ftr__item--col0').clone())
							.html(),
						col1 = $('<ul/>')
							.append(outerElement.find('.nav-ftr__item--col1').clone())
							.html(),
						col2 = $('<ul/>')
							.append(outerElement.find('.nav-ftr__item--col2').clone())
							.html(),
						col3 = $('<ul/>')
							.append(outerElement.find('.nav-ftr__item--col3').clone())
							.html(),
						col4 = $('<ul/>')
							.append(outerElement.find('.nav-ftr__item--col4').clone())
							.html();

					outerElement.empty().append('<li><ul class="meganav-outer"><li class="col0"><ul>' + col0 + '</ul></li><li class="separator"></li><li class="col1"><ul>' + col1 + '</ul></li><li class="separator"></li><li class="col2"><ul>' + col2 + '</ul></li><li class="separator"></li><li class="col3"><ul>' + col3 + '</ul></li><li class="separator"></li><li class="col4"><ul>' + col4 + '</ul></li></ul></li>');

					// Move socials
					$('nav.footer-nav .socials').appendTo('nav.footer-nav ul.meganav-outer>li.col4');
				}
			}
		},

		/**
		 * Activate mobile menu actions
		 */
		mobileMenuActions: function() {
			$('div.nav-main-toggle').on('click', function() {
				// Toggle open class and measurement
				$('body').toggleClass('nav-main-open');
				if ($('body').hasClass('nav-main-open')) {
					$('body').css('overflow', 'hidden');

					// Fill screen
					$('ul.nav-main').css('height', $(window).height() - $('header.main-header nav.main-nav').outerHeight() + 1);

					// Copy the utility nav items into the main nav
					$('.nav-main').append($('.nav-util li').clone().addClass('cloned-nav'));
					$('.nav-main').prepend($('.nav-util-outer form').clone().addClass('cloned-nav'));
					$('form.cloned-nav').wrap('<li class="cloned-nav"></li>');

					// Copy the jump nav into the main nav
					$('.nav-main').append($('.jump-modal-inner').clone().addClass('cloned-nav'));
					$('.jump-modal-inner.cloned-nav').wrap('<li class="cloned-nav jump-nav-mobile"></li>');

				} else {

					// Clean up the previous state
					$('.cloned-nav').remove();
					$('ul.nav-main').css('height', '');
					$('body').css('overflow', '');
				}

				// Light up the subnavs
				$('ul.nav-main>li.menu-item-has-children')
					.off()
					.on('click', function(event) {
						if (!$(event.target).is('a')) {
							$(this).toggleClass('active');
						}
					});
			});

			// One last check to remove mobile mods if screen resize above mobile resolution
			$(window).on('resize', function() {
				if (Modernizr.mq('(min-width: 1000px)') && $('body').hasClass('nav-main-open')) {
					$('body').removeClass('nav-main-open');
					$('.cloned-nav').remove();
					$('ul.nav-main').css('height', '');
					$('body').css('overflow', '');
				}
			});
		},

		/**
		 * Activate split/jump menu widgets
		 */
		activateSplitMenus: function() {
			$('ul.jump-menu').on('click', function() {
				$(this).toggleClass('active');
				$('ul.jump-menu')
					.not(this)
					.removeClass('active');
			});
		},

		/**
		 * Adds sticky click state to first-level navigation items
		 */
		touchDesktopMenus: function() {
			var topLevelMenus = $('.nav-main > li.menu-item-has-children > a');
			if (topLevelMenus.length > 0) {
				topLevelMenus.each(function() {
					$(this).on('click touchend', function(event) {
						if (Modernizr.mq('(min-width: 1000px)')) {
							var parentContainer = $(this).parent();

							// Prevent default link behavior - must double-click
							event.preventDefault();

							// Close open menus
							topLevelMenus
								.not(this)
								.parent()
								.removeClass('active');

							// Already open - must've meant to go to link
							if (parentContainer.hasClass('active')) {
								window.location = $(this).attr('href');
							} else {
								parentContainer.addClass('active');
							}
						}
					});
				});

				// Kill menus when clicked outside
				$(document).on('click touchend', function(event) {
					if (Modernizr.mq('(min-width: 1000px)') && !$(event.target).is('.nav-main > li.menu-item-has-children > a')) {
						$('.nav-main > li.menu-item-has-children').removeClass('active');
					}
				});
			}

			// Open button on fullscreen jump modal
			$('.jump-menu').on('click', function() {
				$('body').addClass('jump-modal-open');
			});

			// Close button on fullscreen jump modal
			$('.jump-modal').on('click', function() {
				$('body').removeClass('jump-modal-open');
			});
		}

	};

	return navigation;
})(jQuery);

jQuery(document).ready(function() {
	navigationController.init();
});
